interface FilterCategoryMapping {
  key: string
  groupName: string
  translationKey: string
  filterIds: string[]
}

export const CDCMappings: FilterCategoryMapping[] = [
  {
    key: 'sales_and_promotions',
    groupName: 'Sales and promotions',
    translationKey: 'filters.offers',
    filterIds: ['ent_4nightsfor3', 'ent_3nightsfor2'],
  },
  {
    key: 'stay_type_and_collections',
    groupName: 'Stay type and collections',
    translationKey: 'filters.startypes-collections',
    filterIds: [
      'ent_luxurycollection',
      'ent_romanticgetaways',
      'ent_trulyunique',
      'ent_ecostays',
      'ent_glampingcollection',
      'ent_grouped',
      'ent_christmasdecor',
      'ent_choice',
      'ent_newlylistedproperties',
      'ent_bookbefore',
    ],
  },
  {
    key: 'location_and_surroundings',
    groupName: 'Location and surroundings',
    translationKey: 'filters.locations-surrounding',
    filterIds: [
      'ent_rural',
      'ent_coastalwithin1mile',
      'ent_coastalwithin3miles',
      'ent_coastalwithin5miles',
      'ent_seaview',
      'ent_beachnearby',
      'ent_waterside',
      'ent_golf',
      'ent_fishing',
      'ent_pub',
      'ent_train',
    ],
  },
  {
    key: 'facilities_and_amenities',
    groupName: 'Facilities and amenities',
    translationKey: 'filters.facilities-amenities',
    filterIds: [
      'ent_wifiac',
      'ent_parkingonsite',
      'ent_evchargingpoint',
      'ent_washingmachine',
      'ent_dishwasher',
      'ent_openfirewoodburningstove',
      'ent_gardenorpatio',
      'ent_enclosedgardenpatio',
      'ent_barbecue',
      'ent_decking',
      'ent_bicyclestore',
      'ent_bicyclesavailable',
    ],
  },
  {
    key: 'wellness_and_leisure',
    groupName: 'Wellness and leisure facilities',
    translationKey: 'filters.leisure-wellness',
    filterIds: [
      'ent_swimmingpool',
      'ent_hottubprivate',
      'ent_sauna',
      'ent_steamroom',
      'ent_childplay',
      'ent_familygames',
    ],
  },
  {
    key: 'accessibility_and_layout',
    groupName: 'Accessibility and layout',
    translationKey: 'filters.accessibility',
    filterIds: [
      'ent_groundfloorfacil',
      'ent_ensuite',
      'ent_wheelchairaccessible',
    ],
  },
  {
    key: 'pets',
    groupName: 'Pets',
    translationKey: 'filters.pets',
    filterIds: [
      'ent_petsallowed',
      'ent_petsfree',
      'ent_petsnotaccepted',
      'ent_morethandogfriendly',
    ],
  },
  {
    key: 'family_and_baby',
    groupName: 'Family and baby',
    translationKey: 'filters.family',
    filterIds: [
      'ent_cot',
      'ent_highchair',
      'ent_babyandtoddlerfriendly',
      'ent_childplay',
      'ent_familygames',
    ],
  },
]

export const HOSMappings: FilterCategoryMapping[] = [
  {
    key: 'sales_and_promotions',
    groupName: 'Sales and offers',
    translationKey: 'filters.offers',
    filterIds: ['ent_3nightsfor2', 'ent_4nightsfor3', 'ent_dogsgofree'],
  },
  {
    key: 'stay_type_and_collections',
    groupName: 'Stay type and collections',
    translationKey: 'filters.startypes-collections',
    filterIds: [
      'ent_luxurycollection',
      'ent_hosautograph',
      'ent_hosbouja',
      'ent_hoswanderwood',
      'ent_hosgoactive',
      'ent_hosgoactiveplus',
      'ent_hosautographplus',
      'ent_glampingcollection',
      'ent_diamondawardwinners',
      'ent_hosevermore',
      'ent_hosmagnificent',
      'ent_watersidebreaks',
      'ent_hostailormade',
      'ent_hosdaisydoor',
      'ent_hosrelaxandexplore',
      'ent_hoslodgeescape',
      'ent_trulyunique',
      'ent_bestsellers',
      'ent_newlylistedproperties',
      'ent_newparkfor2025',
    ],
  },
  {
    key: 'location_and_surroundings',
    groupName: 'Location and surroundings',
    translationKey: 'filters.locations-surrounding',
    filterIds: ['ent_beachnearby', 'ent_seaview', 'ent_golf', 'ent_fishing'],
  },
  {
    key: 'facilities_and_amenities',
    groupName: 'Facilities and amenities',
    translationKey: 'filters.facilities-amenities',
    filterIds: [
      'ent_wifiac',
      'ent_parkingonsite',
      'ent_evchargingpoint',
      'ent_washingmachine',
      'ent_dishwasher',
      'ent_openfirewoodburningstove',
      'ent_barbecue',
      'ent_decking',
      'ent_golfonsite',
      'ent_bicyclesavailable',
      'ent_bicyclestore',
    ],
  },
  {
    key: 'wellness_and_leisure',
    groupName: 'Wellness and leisure facilities',
    translationKey: 'filters.leisure-wellness',
    filterIds: [
      'ent_hottubprivate',
      'ent_swimmingpool',
      'ent_sauna',
      'ent_spaandbeauty',
      'ent_childplay',
      'ent_steamroom',
      'ent_familygames',
      'ent_familyentertainment',
      'ent_sportsbar',
    ],
  },
  {
    key: 'accessibility_and_layout',
    groupName: 'Accessibility and layout',
    translationKey: 'filters.accessibility',
    filterIds: ['ent_wheelchairaccessible'],
  },
  {
    key: 'pets',
    groupName: 'Pets',
    translationKey: 'filters.pets',
    filterIds: ['ent_petsallowed', 'ent_petsfree', 'ent_petsnotaccepted'],
  },
  {
    key: 'family_and_baby',
    groupName: 'Family and baby',
    translationKey: 'filters.family',
    filterIds: [
      'ent_childplay',
      'ent_cot',
      'ent_highchair',
      'ent_kidsclub',
      'ent_hosfamilyfunplus',
      'ent_familygames',
      'ent_familyentertainment',
      'ent_hosfamilyfun',
    ],
  },
]

export const NOVMappings: FilterCategoryMapping[] = [
  {
    key: 'sales_and_promotions',
    groupName: 'Sales and offers',
    translationKey: 'filters.offers',
    filterIds: ['ent_petsfree', 'ent_4nightsfor3', 'ent_3nightsfor2'],
  },
  {
    key: 'property_type',
    groupName: 'Property type',
    translationKey: 'filters.accomodation-type',
    filterIds: [
      'ent_apartment',
      'ent_holidayhome',
      'ent_holidayparkeu',
      'ent_houseboat',
      'ent_glampingcollection',
      'ent_grouped',
    ],
  },
  {
    key: 'stay_type_and_collections',
    groupName: 'Stay type and collections',
    translationKey: 'filters.startypes-collections',
    filterIds: [
      'ent_luxurycollection',
      'ent_romanticgetaways',
      'ent_ecostays',
      'ent_choice',
      'ent_newlylistedproperties',
      'ent_bookbefore',
      'ent_christmasdecor',
      'ent_canolabel',
      'ent_shortbreak',
      'ent_flexiblearrival',
      'ent_energysavingprop',
    ],
  },
  {
    key: 'location_and_surroundings',
    groupName: 'Location and surroundings',
    translationKey: 'filters.locations-surrounding',
    filterIds: [
      'ent_beachnearby',
      'ent_beachfront',
      'ent_coastalwithin1mile',
      'ent_coastalwithin3miles',
      'ent_coastalwithin5miles',
      'ent_seaview',
      'ent_scenicviews',
      'ent_rural',
      'ent_waterside',
      'ent_train',
      'ent_pub',
      'ent_golf',
      'ent_fishing',
      'ent_boatavailable',
    ],
  },
  {
    key: 'facilities_and_amenities',
    groupName: 'Facilities and amenities',
    translationKey: 'filters.facilities-amenities',
    filterIds: [
      'ent_wifiac',
      'ent_parkingonsite',
      'ent_aircon',
      'ent_dishwasher',
      'ent_washingmachine',
      'ent_evchargingpoint',
      'ent_openfirewoodburningstove',
      'ent_bicyclestore',
      'ent_bicyclesavailable',
      'ent_allinclusive',
      'ent_gardenorpatio',
      'ent_enclosedgardenpatio',
      'ent_decking',
      'ent_barbecue',
    ],
  },
  {
    key: 'wellness_and_leisure',
    groupName: 'Leisure and wellness',
    translationKey: 'filters.leisure-wellness',
    filterIds: [
      'ent_swimmingpool',
      'ent_hottubprivate',
      'ent_hottubspabathnov',
      'ent_sauna',
      'ent_steamroom',
      'ent_wellness',
      'ent_freeentrywaterpark',
    ],
  },
  {
    key: 'accessibility_and_layout',
    groupName: 'Accessibility and layout',
    translationKey: 'filters.accessibility',
    filterIds: [
      'ent_wheelchairaccessible',
      'ent_groundfloorfacil',
      'ent_ensuite',
    ],
  },
  {
    key: 'family_and_baby',
    groupName: 'Family and baby',
    translationKey: 'filters.family',
    filterIds: [
      'ent_babyandtoddlerfriendly',
      'ent_cot',
      'ent_highchair',
      'ent_familygames',
      'ent_childplay',
    ],
  },
  {
    key: 'pets',
    groupName: 'Pets',
    translationKey: 'filters.pets',
    filterIds: [
      'ent_petsallowed',
      'ent_petsfree',
      'ent_petsnotaccepted',
      'ent_morethandogfriendly',
    ],
  },
]

export const CDCUsageMap = [
  'popularFeatures',
  'bedrooms',
  'facilities_and_amenities',
  'bathrooms',
  'price',
  'location_and_surroundings',
  'popularDestinations',
  'starRating',
  'extras',
  'sales_and_promotions',
  'pets',
  'accessibility_and_layout',
  'customerReviewScore',
  'family_and_baby',
  'stay_type_and_collections',
  'wellness_and_leisure',
]

export const NOVUsageMap = [
  'popularFeatures',
  'sales_and_promotions',
  'property_type',
  'stay_type_and_collections',
  'location_and_surroundings',
  'facilities_and_amenities',
  'wellness_and_leisure',
  'accessibility_and_layout',
  'family_and_baby',
  'pets',
  'bedrooms',
  'price',
  'starRating',
  'bathrooms',
  'extras',
  'customerReviewScore',
]

export const HOSUsageMap = [
  'popularFeatures',
  'bedrooms',
  'popularDestinations',
  'facilities_and_amenities',
  'location_and_surroundings',
  'sales_and_promotions',
  'price',
  'bathrooms',
  'family_and_baby',
  'wellness_and_leisure',
  'customerReviewScore',
  'stay_type_and_collections',
  'accessibility_and_layout',
  'pets',
]

export const FilterAccordionOrderByBrand: Record<string, string[]> = {
  'cottages.com': [
    'bedrooms',
    'facilities_and_amenities',
    'bathrooms',
    'price',
    'location_and_surroundings',
    'popularDestinations',
    'starRating',
    'extras',
    'pets',
    'accessibility_and_layout',
    'customerReviewScore',
    'family_and_baby',
    'stay_type_and_collections',
    'wellness_and_leisure',
  ],
  hoseasons: HOSUsageMap,
  novasol: NOVUsageMap,
  fincallorca: NOVUsageMap,
  jamesVillas: NOVUsageMap,
}
